import { InputHTMLAttributes } from "react";
import styled, { css } from "styled-components";

export const FormLabel = styled.label<{ $textColor?: string }>`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  color: ${(props) => props.$textColor || "var(--black)"};
  display: block;
  margin-bottom: 0.5rem;
  text-align: left;
`;

export const Input = styled.input<
  InputHTMLAttributes<HTMLInputElement> & { 
    $backgroundColor?: string, 
    $borderColor?: string, 
    $focusBorderColor?: string, 
    $placeholderColor?: string
    $textColor?: string,
  }
>`
  font-family: "Montserrat", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  background: ${(props) => props.$backgroundColor || "var(--white)"};
  color: ${(props) => props.$textColor || "var(--black)"};
  padding: 0.5rem;
  border-radius: 0.125rem;
  border: 1px solid ${(props) => props.$borderColor || "transparent"};
  display: block;
  height: 3.125rem;
  width: 100%;

  &:focus {
    border-radius: 0.125rem;
    border: 2px solid ${(props) => props.$focusBorderColor || "var(--yellow-500)"};
    outline: none;
  }

  &::placeholder {
    font-size: 1rem;
    line-height: 1.5rem;
    color: ${(props) => props.$placeholderColor || "var(--gray-100)"};
    font-weight: 800;
  }

  /* Autofill styles */
  &:-webkit-autofill {
    background: ${(props) => props.$backgroundColor || "var(--white)"} !important;
    color: ${(props) => props.$textColor || "var(--black)"} !important;
    -webkit-text-fill-color: ${(props) => props.$textColor || "var(--black)"} !important;
    transition: background-color 5000s ease-in-out 0s; /* Prevent flashing */
  }

  &:-webkit-autofill::first-line {
    font-family: "Montserrat", sans-serif;
    font-size: 1rem;
    font-weight: 500;
  }
`;

export const FormErrorMessage = styled.small`
  font-size: 0.75rem;
  line-height: 1.125rem;
  color: var(--red);
  margin-top: 0.25rem;
  display: block;
`;

export const FormControl = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isInvalid"].includes(prop),
})<{ isInvalid?: boolean }>`
  ${FormLabel} {
    ${(props) =>
      props.isInvalid &&
      css`
        color: var(--red);
      `};
  }

  ${Input} {
    ${(props) =>
      props.isInvalid &&
      css`
        border: 1px solid var(--red);

        &:not(:focus)::placeholder {
          color: var(--red);
          font-weight: 600;
        }
      `};

    &:focus {
      ${(props) =>
        props.isInvalid &&
        css`
          border: 1px solid var(--red);
        `};
    }
  }
`;
